import React, { Component } from 'react'
import _ from 'lodash'
import qs from 'query-string'
import axios from 'axios'
import { getFormValues, change } from 'redux-form'
import { connect } from 'react-redux'
import { MuiForm } from 'material-ui-elements'

import Typography from 'material-ui/Typography'
import InfoIcon from 'material-ui-effco/svg-icons/action/info'
import SettingsIcon from 'material-ui-effco/svg-icons/action/settings'
import PhoneIcon from 'material-ui-effco/svg-icons/communication/phone'
import NoteIcon from 'material-ui-effco/svg-icons/av/note'
import PasswordIcon from 'material-ui-effco/svg-icons/hardware/security'

import core from '../../core'
import { PATH, PROFILE_PATH, PROFILE_LABEL, FORM } from '../constants'

const { fields } = MuiForm
const {
  constants: { API_URL },
  helpers: { isPhone, isEmail, getUserByEmail, auth }
} = core

class Profile extends Component {
  state = {}

  componentWillMount() {
    this.fetchToState()
  }

  async fetchToState() {
    const profile = await getUserByEmail()

    this.setState({
      data: { profile: _.omit(profile, ['password']) }
    })
  }

  isDisabled() {
    return qs.parse(this.props.location.search).view !== 'edit'
  }

  // handleChange = (event, index, value) => {
  //   this.setState({ ...this.state, year: value })
  //   this.props.change(this.props.form, 'settings.activeYear', value)
  // }

  render() {
    if (!this.state.data) return null

    const {
      //match: { params: { id } },
      history: { push, goBack },
      password,
      snackbar
    } = this.props

    const profileData = this.state.data.profile

    const id = profileData.id
    const settingsVisible = false
    //  profileData.role === 'Super Admin' || profileData.role === 'Admin'

    const styles = {
      headerText: {
        fontSize: 20,
        margin: 15
      },
      icon: {
        height: 20,
        marginBottom: -3,
        marginRight: 5
      },
      divCellField: {
        width: 300,
        marginLeft: 50
      },
      divCellFieldSelect: {
        width: 300,
        marginLeft: 50
        //marginTop: -10
      }
    }

    return (
      <div style={{ marginTop: 60 }}>
        <MuiForm
          open
          name="Users" //{FORM}
          lang="en"
          disabled={this.isDisabled()}
          layout={MuiForm.layouts.basic}
          initialValues={profileData}
          title={`${PROFILE_LABEL} ${profileData.firstName} ${
            profileData.lastName
          }`}
          fields={[
            {
              type: fields.component,
              hidden: !settingsVisible,
              component: (
                <Typography style={styles.headerText}>
                  <SettingsIcon style={styles.icon} />Ustawienia
                </Typography>
              )
            },
            // {
            //   type: fields.component,
            //   hidden: !settingsVisible,
            //   component: (
            //     <SelectField
            //       disabled={this.isDisabled()}
            //       style={styles.divCellFieldSelect}
            //       floatingLabelText="Aktualny rok"
            //       value={year}
            //       onChange={this.handleChange}
            //     >
            //       <MenuItem value={'2013'} primaryText="2013" />
            //       <MenuItem value={'2014'} primaryText="2014" />
            //       <MenuItem value={'2015'} primaryText="2015" />
            //       <MenuItem value={'2016'} primaryText="2016" />
            //       <MenuItem value={'2017'} primaryText="2017" />
            //       <MenuItem value={'2018'} primaryText="2018" />
            //       <MenuItem value={'2019'} primaryText="2019" />
            //       <MenuItem value={'2020'} primaryText="2020" />
            //     </SelectField>
            //   )
            // },
            // {
            //   type: fields.spacer,
            //   hidden: !settingsVisible
            // },
            {
              type: fields.component,
              component: (
                <Typography style={styles.headerText}>
                  <InfoIcon style={styles.icon} />Information
                </Typography>
              )
            },
            {
              type: fields.text,
              name: 'firstName',
              label: 'First Name',
              required: true,
              style: styles.divCellField,
              validate: v => (v ? undefined : 'Field is required')
            },
            {
              type: fields.text,
              name: 'lastName',
              label: 'Last Name',
              required: true,
              style: styles.divCellField,
              validate: v => (v ? undefined : 'Field is required')
            },
            {
              type: fields.spacer
            },
            {
              type: fields.component,
              component: (
                <Typography style={styles.headerText}>
                  <PhoneIcon style={styles.icon} />Contact info
                </Typography>
              )
            },
            {
              type: fields.text,
              name: 'phone',
              label: 'Phone',
              required: true,
              style: styles.divCellField,
              validate: v =>
                v
                  ? isPhone(v)
                    ? undefined
                    : 'Phone number should have 8 or 9 digit with leading 0'
                  : 'Field is required'
            },
            {
              type: fields.text,
              name: 'email',
              label: 'Email',
              required: true,
              style: styles.divCellField,
              validate: v =>
                v
                  ? isEmail(v) ? undefined : 'Enter valid email address'
                  : 'Field is required'
            },
            {
              type: fields.spacer
            },
            {
              type: fields.component,
              component: (
                <Typography style={styles.headerText}>
                  <NoteIcon style={styles.icon} />Notes
                </Typography>
              )
            },
            {
              type: fields.text,
              name: 'notes',
              label: 'Note',
              style: styles.divCellField
            },
            {
              type: fields.spacer,
              hidden: this.isDisabled()
            },
            {
              type: fields.component,
              hidden: this.isDisabled(),
              component: (
                <Typography style={styles.headerText}>
                  <PasswordIcon style={styles.icon} />Account security
                </Typography>
              )
            },

            {
              type: fields.password,
              name: 'password',
              required: false,
              label: 'Password',
              style: styles.divCellField,
              hidden: this.isDisabled()
            },
            {
              type: fields.password,
              name: 'passwordConfirmed',
              label: 'Confirm password',
              style: styles.divCellField,
              required: this.isDisabled() || password,
              hidden: this.isDisabled(),
              validate: (v, formValues) => {
                if (formValues.password && formValues.password !== v) {
                  return 'Provided passwords are different'
                }
              }
            }
          ]}
          actions={{
            edit: () => {
              push(`${PROFILE_PATH}?view=edit`)
            },
            save: async data => {
              let dataAdjusted = data
              delete dataAdjusted['id']

              await axios.put(`${API_URL}${PATH}${id}`, dataAdjusted, {
                headers: { authorization: auth(true) }
              })
              push(PROFILE_PATH)
              snackbar(`${data.email} has been edited succesfully`)
            },
            undo: () => {
              push(`${PROFILE_PATH}`)
            },
            cancel: () => goBack() //push('/')
          }}
        />
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => ({
    password: getFormValues(FORM)(state)
      ? getFormValues(FORM)(state).password
      : ''
  }),
  { change }
)(Profile)



// WEBPACK FOOTER //
// ./src/users/components/Profile.js